import axios from "axios";

export const BASE_URL = "https://map.goteclabs.com/api/web";

export default axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
});

export const axiosToken = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json" },
});
